<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض طلبات التسجيل</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>إسم الطالب </th>
                    <td>{{ student.student.first_name + ' ' + student.student.last_name}}</td>
                  </tr>
                  <tr>
                    <th>رقم الهاتف</th>
                    <td>{{ student.student.mobile }}</td>
                  </tr>
                  <tr>
                    <th>البريد الإلكتروني</th>
                    <td>{{ student.student.email }}</td>
                  </tr>
                </table>
            </div>
            <div class="col-md-6">
              <table class="table table-bordered">
                <tr>
                    <th> إسم الدورة</th>
                    <td>{{ student.course.name_ar }}</td>
                </tr>
                <tr>
                    <th> تكلفة الدورة</th>
                    <td>{{ student.courseCost}}</td>
                </tr>
                <tr>
                    <th>عدد الدروس</th>
                    <td>{{ student.lessonsCount }}</td>
                </tr>
                <tr>
                    <th>نسبة الحضور في الدورة</th>
                    <td>{{ student.courseProgress }}</td>
                </tr>
              </table>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-bordered">
              <tr>
                <th>عنوان الدرس</th>
                <th>نسبة المشاهدة في الفديو</th>
                <th>تاريخ اخر تحديث</th>
              </tr>
              <tr v-for="lessonProgress in student.progress" v-bind:key="lessonProgress.id">
                <td>{{lessonProgress.lesson.title_ar}}</td>
                <td>{{lessonProgress.progress + ' %'}} </td>
                <td>{{lessonProgress.updated_at | formatDate}}</td>
              </tr>
            </table>
          </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>

export default {
  name: 'Show',
  data () {
    return {
      student: []
    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}courses-students/${this.$route.params.id}`)
      .then((response) => {
        this.student = response.data.data
        console.log(this.student)
      })
  },
  methods: {
    goBack () {
      this.studentsOpened ? this.$router.go(-1) : this.$router.push({ path: '/courses-students' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
